exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".support__languages___3Q2jG ul{margin:20px 0;padding:0;list-style:none;font-weight:700}.support__languages___3Q2jG ul li{margin:0;padding:0}.support__languages___3Q2jG ul li a{display:inline-block;width:100%;margin:-1px 0 0;border:1px solid #e9f2f6;padding:10px}.support__selected___1KhSb a{background-color:#e9f2f6}.support__materialList___1WXhw{margin:5px 0}.support__material___3ezsk{display:inline-block;width:100%;min-height:300px;padding:10px;margin:15px 0;text-align:center;border:1px solid #e9f2f6;text-decoration:none}.support__material___3ezsk img{width:100px;opacity:.1}.support__material___3ezsk h3{color:#00aeef}.support__material___3ezsk p{color:#888}.support__material___3ezsk:hover{background-color:#e9f2f6;text-decoration:none}", ""]);

// exports
exports.locals = {
	"languages": "support__languages___3Q2jG",
	"selected": "support__selected___1KhSb",
	"materialList": "support__materialList___1WXhw",
	"material": "support__material___3ezsk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/support.scss
// module id = 1077
// module chunks = 0